<template>
  <Layout>
    <div class="mc-template-form">
      <PageHeaderV2 :title="title" class="mc-page-three">
        <template #afterTitle>
          <McButtonBack />
        </template>
      </PageHeaderV2>
      <FormulateForm
        name="fleet-task-expense-template"
        v-model="formValues"
        ref="formRef"
        class="mc-form"
        :errors="formErrors"
      >
        <div class="mc-header__template-info d-flex">
          <h4 class="card-title flex-grow-1">{{ $t('global.information') }}</h4>
          <McButton
            @click="$refs['mc-modal-cancel'].show()"
            variant="secondary"
            class="mx-2"
            :text="$t('global.cancel')"
            icon="icon-outline_close"
            :disabled="disableMainFormBtns"
          />
          <b-modal
            class="mc-modal"
            id="mc-modal-cancel"
            ref="mc-modal-cancel"
            :title="$t('global.action.cancel')"
            size="md"
            centered
            scrollable
          >
            <div class="card-body p-2">
              <p>
                {{ $t('global.text.modal.cancelChange') }}
                <strong>{{ $t('setting.list.fleetTaskCost.info') }}</strong
                >?
              </p>
            </div>
            <template #modal-footer="{ cancel }">
              <div class="d-flex mx-0">
                <McButton
                  @click="cancel()"
                  variant="secondary"
                  class="me-2"
                  :text="$t('global.action.no')"
                />
                <McButton @click="handleCancel" variant="primary" :text="$t('global.action.yes')" />
              </div>
            </template>
          </b-modal>

          <McButton
            variant="primary"
            type="submit"
            ref="save-button-ref"
            icon="icon-outline_save"
            :text="this.$t('global.save')"
            :disabled="disableMainFormBtns"
            @click="handleSubmit"
          />

          <b-modal
            class="mc-modal"
            id="mc-modal-update"
            ref="mc-modal-update"
            title="Simpan"
            size="md"
            centered
            scrollable
          >
            <div class="card-body p-2">
              <p>
                {{ $t('global.text.modal.saveChange') }}
                <strong>{{ $t('setting.list.fleetTaskCost.info') }}</strong
                >?
              </p>
            </div>
            <template #modal-footer="{ cancel }">
              <div class="d-flex mx-0">
                <McButton
                  @click="cancel()"
                  variant="secondary"
                  class="me-2"
                  :text="$t('global.action.no')"
                />
                <McButton @click="submitUpdate" variant="primary" :text="$t('global.action.yes')" />
              </div>
            </template>
          </b-modal>
        </div>
        <b-card class="mc-template-info__card">
          <b-row class="g-0">
            <div class="mc-template-info__input-group">
              <div v-for="field in fields" :key="field.name">
                <FormulateInput
                  v-bind="field"
                  :ref="`${field.name}-ref`"
                  class="mc-template-info__input"
                  validation-behavior="live"
                  :fullObject.sync="templateObj"
                  :disabled="disableMainFormInput"
                />
              </div>
            </div>
          </b-row>
        </b-card>
      </FormulateForm>
      <TableTemplateItems
        ref="template-table"
        :apiClient="templateApiClient"
        :invalidFields="invalidFields"
      />
    </div>
  </Layout>
</template>
<script>
import isEqual from 'lodash/isEqual'
import errorMessageList from './lib/constants/error-message-mapper'
import Layout from '@/router/layouts/main'
import PageHeaderV2 from '@/components/page-header-v2'
import { fields } from './lib/fields/create/main'
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'
import TableTemplateItems from './components/TemplateItems/index'
import McButtonBack from '@/components/McButtonBack'
import * as TemplateExpense from '@/services/rest-api/lib/template/fleet-task-expense/main'
import * as TemplateItems from '@/services/rest-api/lib/template/fleet-task-expense/items'

export default {
  components: {
    Layout,
    PageHeaderV2,
    McButton,
    TableTemplateItems,
    McButtonBack,
  },
  data() {
    return {
      title: 'Template Biaya Baru',
      formValues: {},
      formErrors: {},
      isLoading: false,
      templateObj: {},
      invalidFields: [],
      isSubmitting: false,
      templateData: {},
      errorResponse: null,
      invalidFormValues: {},
      fields,
    }
  },
  computed: {
    templateId() {
      return this.$route.params.id ?? null
    },
    isAdding() {
      return this.$route.params.id === undefined
    },
    hasChanged() {
      if (this.isLoading) return false

      let currentFormValues = this.formValues
      let oldFormValues = {}

      if (!this.isAdding) oldFormValues = this.templateData

      const res = this.filterUnchangedData(currentFormValues, oldFormValues)
      return res[1]
    },
    templateApiClient() {
      if (!this.$route.params.id) return
      return {
        get: TemplateExpense.getItems,
        show: TemplateItems.show,
        update: TemplateItems.update,
        store: TemplateItems.store(this.$route.params.id),
        delete: TemplateItems.deleteSingle(this.$route.params.id),
      }
    },
    invalidFieldKeys() {
      return Object.keys(this.invalidFormValues)
    },
    disableMainFormBtns() {
      return !this.hasChanged || this.isSubmitting || this.isLoading
    },
    disableMainFormInput() {
      return this.isSubmitting || this.isLoading
    },
  },
  watch: {
    async formValues() {
      if (this.invalidFieldKeys.length === 0) return

      this.invalidFieldKeys.forEach((fieldErrorKey) => {
        if (this.invalidFormValues[fieldErrorKey] != this.formValues[fieldErrorKey]) {
          // delete the field from the state to show errors
          this.$delete(this.formErrors, fieldErrorKey)
          this.$delete(this.invalidFormValues, fieldErrorKey)
        }
      })

      // empty the errorResponse if all error key is deleted
      if (this.invalidFieldKeys.length === 0) {
        this.errorResponse = {}
        this.invalidFormValues = {}
      }
    },
  },
  mounted() {
    if (this.isAdding) return
    this.showData()
  },
  methods: {
    async handleCancel() {
      this.formValues = this.templateData
      this.resetErrors()
      this.$formulate.resetValidation('fleet-task-expense-template')

      this.$refs['mc-modal-cancel'].hide()
    },
    filterUnchangedData(newValue, oldValue) {
      const keys = new Set([...Object.keys(newValue), ...Object.keys(oldValue)])
      const _newValue = {}

      keys.forEach((key) => {
        // if both value is falsy
        if (!oldValue[key] && !newValue[key]) return

        // if oldValue has same value with newValue
        if (oldValue[key] == newValue[key]) return

        // if the oldValue is 'Invalid date' and newValue is null
        if (oldValue[key] === 'Invalid date' && newValue[key] === null) return

        // if it is array
        if (Array.isArray(oldValue[key]) || Array.isArray(newValue[key])) {
          // if oldValue is undefined but the newValue is empty array
          if (!oldValue[key] && newValue[key].length === 0) return

          // matching oldValue and newValue array
          const sortedNewValue = newValue[key]?.length ? newValue[key].sort() : newValue[key]
          const sortedOldValue = oldValue[key] ? oldValue[key].sort() : oldValue[key]

          const isSameArray = isEqual(sortedNewValue, sortedOldValue)

          if (isSameArray) return
        }

        _newValue[key] = newValue[key]
      })

      const entries = Object.entries(_newValue)
      const hasChanged = entries.length > 0 && entries.every((value) => value)
      return [_newValue, hasChanged]
    },
    handleSubmit() {
      if (this.isSubmitting) return this.$mcToast.warning('Mohon tunggu')

      if (this.$refs.formRef.hasErrors || this.invalidFieldKeys.length) {
        this.$mcToast.error('Terdapat kesalahan format pada input anda')
        return
      }

      if (this.isAdding) {
        this.submitStore()
      } else {
        this.$refs['mc-modal-update'].show()
      }
    },
    async showData(templateId = null) {
      this.isLoading = true

      const { errors, data } = await TemplateExpense.show(templateId ?? this.templateId)

      this.formValues = { name: data.name, description: data.description }
      this.templateData = { name: data.name, description: data.description }
      this.isLoading = false

      // assign the errors
      if (errors) {
        await this.assignErrors(errors)
      }
    },
    async submitStore() {
      try {
        this.isSubmitting = true

        const { errors, message, data } = await TemplateExpense.store({
          name: this.formValues.name,
          description: this.formValues.description,
        })

        if (errors) {
          if (Helper.methods.isObject(errors)) {
            await this.assignErrors(errors)
          } else {
            this.$mcToast.error(message)
          }

          this.isSubmitting = false
          return
        }

        this.$mcToast.success('Berhasil menyimpan template')

        this.$router.push({ name: 'Detail Fleet Task Expense', params: data })
        await this.showData(data.id)

        this.isSubmitting = false
      } catch (e) {
        this.$mcToast.error('Terjadi kesalahan.')
      } finally {
        this.isSubmitting = false
      }
    },
    async submitUpdate() {
      try {
        this.isSubmitting = true

        const { errors, message } = await TemplateExpense.update(this.templateId, {
          name: this.formValues.name,
          description: this.formValues.description,
        })

        if (errors) {
          if (Helper.methods.isObject(errors)) {
            await this.assignErrors(errors)
          } else {
            this.$mcToast.error(message)
          }

          this.isSubmitting = false
          return
        }

        this.$mcToast.success('Berhasil memperbarui template.')

        await this.showData(this.templateId)

        this.isSubmitting = false
      } catch (e) {
        this.$mcToast.error('Terjadi kesalahan.')
      } finally {
        this.isSubmitting = false
        this.$refs['mc-modal-update'].hide()
      }
    },
    resetErrors() {
      this.formErrors = {}
      this.errorResponse = {}
      this.invalidFormValues = {}
      this.validationAlreadyFailed = false
    },
    async assignErrors(errors) {
      if (Object.keys(errors).length === 0) return
      const fieldErrorKeys = Object.keys(errors)

      this.resetErrors()
      this.invalidCostFields = []

      await this.$nextTick()

      // assign the error field to loadstable, form errors and duplicate the form values with field that error
      fieldErrorKeys.forEach((fieldErrorKey) => {
        // assign the proper key to show the error message
        this.$set(this.invalidFormValues, fieldErrorKey, this.formValues[fieldErrorKey])
        this.$set(
          this.formErrors,
          fieldErrorKey,
          errorMessageList[fieldErrorKey][errors[fieldErrorKey][0]] ??
            'Terdapat kesalahan format pada input anda'
        )
      })

      await this.$nextTick()
      // assign the errors to a state
      this.errorResponse = errors

      // assign the errors in LoadsTable
      this.$refs['template-table'].AssignInvalidErrors()

      this.$mcToast.error('Terdapat kesalahan format pada input anda')
    },
  },
}
</script>
<style lang="scss" scoped>
:deep(.mc-template-form) {
  .mc-wizard,
  .mc-header__template-info,
  .mc-template-info__read-only,
  .mc-template-info__card {
    display: inline-block;
    margin-top: 0px;
    margin-bottom: 12px;
    width: 100%;
  }

  @include mediaQueryMinWidth('md') {
    .mc-wizard-skeleton {
      max-width: 600px;
    }
  }

  .mc-header__template-info,
  .mc-template-info__read-only {
    margin-top: 12px;
  }
  .custom-mc-wizard {
    width: 165px;
  }
  .mc-template-info__input-group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-top: 12px;
    margin-bottom: 20px;
    justify-content: space-between;
  }

  .mc-template-info__input {
    width: 100%;
    padding: 0px;
  }
}
</style>
